<template>
  <modal-base
    v-if="visible"
    class="home-news"
    title="Novidade no Credere!"
    @close="hide"
  >
    <img
      :src="illustration"
      alt="Ilustração do menu de propostas aprovadas"
      class="home-news-image"
    >

    <p class="home-news-text">
      A partir de uma única simulação você pode cadastar uma proposta em vários bancos.
    </p>

    <p class="home-news-text">
      É mais agilidade no resultado de propostas aprovadas.
    </p>

    <p class="home-news-text">
      É mais agilidade para as suas vendas.
    </p>

    <form-button-group
      align="center"
      mobile
    >
      <form-button
        class="home-news-action"
        v-bind="bind"
      >
        {{ action }}
      </form-button>
    </form-button-group>
  </modal-base>
</template>

<script>
  import moment from 'moment';

  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';

  import ModalBase from '@cordel/components/Modal/Base.vue';

  import { set, get } from '@sdk/helpers/storage/news';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import illustration from '@/assets/images/illustrations/news/multiple-attempts.jpeg';

  const ID = 'multiple-attempts';

  export default {
    name: 'HomeNews',
    components: {
      FormButton,
      FormButtonGroup,

      ModalBase,
    },
    data() {
      return {
        visible: false,
        timeout: null,
        illustration,
      };
    },
    computed: {
      bind() {
        return {
          href: 'https://blog.meucredere.com.br/uma-proposta-varios-bancos',
          target: '_blank',
        };
      },
      action() {
        return 'Saiba mais';
      },
    },
    mounted() {
      // this.init();
    },
    beforeDestroy() {
      clearTimeout(this.timeout);
    },
    methods: {
      init() {
        const existing = get(ID);

        if (!existing || moment(existing).startOf('month').isBefore(moment().startOf('month'))) {
          this.timeout = setTimeout(this.show, 1000);
        }
      },

      show() {
        set(ID);
        this.visible = true;
      },
      hide() {
        this.visible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .home-news {
  }

  .home-news-image {
    display: block;
    margin: 0 auto var(--cordel-spacing-giga);
    width: 100%;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin-bottom: var(--cordel-spacing-xl);
    }
  }

  .home-news-text {
    line-height: var(--cordel-line-height-m);

    & + & {
      margin-top: var(--cordel-spacing-xxxs);
    }
  }

  .home-news-action {
    margin-top: var(--cordel-spacing-giga);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin-top: var(--cordel-spacing-xl);
    }
  }
</style>
